import { Injectable } from '@angular/core';
import {ApiService} from './http/api.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesStructureTeamService {

  constructor(private apiService: ApiService) {
  }

  addSalesStructureTeams(companyId: number, formData: any): any {
    return this.apiService.post(`/${companyId}/sales-structure-teams`, formData);
  }

  editSalesStructureTeams(companyId: number, id: number, formData: any): any {
    return this.apiService.put(`/${companyId}/sales-structure-teams/${id}`, formData);
  }

  getSalesStructureTeams(companyId: number): Observable<any> {
    return this.apiService.get(`/${companyId}/sales-structure-teams`);
  }

  // getSalesStructureTeamDetails(companyId: number): Observable<any> {
  //   return this.apiService.get(`/${companyId}/sales-structure-team-details`);
  // }
  deleteSalesStructureTeam(companyId: number, id: number): Observable<any> {
    return this.apiService.delete(`/${companyId}/sales-structure-teams/${id}`);
  }

  getSalesStructureTeam(companyId: number, id: number): Observable<any> {
    return this.apiService.get(`/${companyId}/sales-structure-teams/${id}`);
  }

  getSalesStructureTeamSupervisorByTeamId(companyId: number, id: number): Observable<any> {
    return this.apiService.get(`/${companyId}/sales-structure-teams/${id}/supervisors`);
  }

  getSalesStructureTeamSupervisors(companyId: number): Observable<any> {
    return this.apiService.get(`/${companyId}/sales-structure-teams/supervisors`);
  }

  getSalespersons(companyId: number): Observable<any> {
    return this.apiService.get(`/${companyId}/sales-structure-teams/salespersons`);
  }

  transferTeam(companyId: number, id: number, formData: any): any {
    return this.apiService.post(`/${companyId}/sales-structure-teams/transfer/${id}`, formData);
  }
}
